module.exports = __webpack_public_path__ + "media/images/gift/gift-step3-cb3fb15db64515c1727738e90d58ddd2.png";